<template>
    <main class="container_dessinmobile" id="DessinMobile">
        <!--section top -->
        <section class="container_dessinmobile__section_top">
            <!-- article top -->
            <article class="container_dessinmobile__section_top__article_top">
                <aside class="container_dessinmobile__section_top__article_top__aside">
                    <div class="container_dessinmobile__section_top__article_top__aside__div">
                        <h1 class="container_dessinmobile__section_top__article_top__aside__div__h1">
                            Mise en plan
                        </h1>
                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_dessinmobile__section_top__article_bottom">
                <aside class="container_dessinmobile__section_top__article_bottom__aside">
                    <div class="container_dessinmobile__section_top__article_bottom__aside__div_top">
                        <img src="@/assets/solidworks-debutant.jpg" alt="Mise en plan"
                            class="container_dessinmobile__section_top__article_bottom__aside__div_top__img">
                    </div>
                    <!-- div bottom -->
                    <div class="container_dessinmobile__section_top__article_bottom__aside__div_bottom">
                        <p class="container_dessinmobile__section_top__article_bottom__aside__div_bottom__p">
                            Les mises en plan sont effectués via des pièces 3D réalisés par le client ou par mes soins.
                            Possible pour des pièces ou des assemblages
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
            </article>
        </section>
        <!-- section bottom-->
        <section class="container_dessinmobile__section_bottom">
            <article class="container_dessinmobile__section_bottom__article_top">
                <aside class="container_dessinmobile__section_bottom__article_top__aside_top">
                    <div class="container_dessinmobile__section_bottom__article_top__aside_top__div_title">
                        <h1 class="container_dessinmobile__section_bottom__article_top__aside_top__div_title__h1">
                            Tarif
                        </h1>
                    </div>
                    <!-- div -->
                    <div class="container_dessinmobile__section_bottom__article_top__aside_top__div_text">
                        <p class="container_dessinmobile__section_bottom__article_top__aside_top__div_text__p">
                            - mise en plan : 80 €/j <br>
                            - Réalisation rapide <br>
                        </p>
                        <p class="container_dessinmobile__section_bottom__article_top__aside_top__div_text__prix">
                            Prix total : 1 600 €
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_dessinmobile__section_bottom__article_top__aside_bottom">
                    <div class="container_dessinmobile__section_bottom__article_top__aside_bottom__div_left">
                        <router-link
                            class="container_dessinmobile__section_bottom__article_top__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_dessinmobile__section_bottom__article_top__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                </aside>
            </article>
            <!-- article bottom-->
            <article class="container_dessinmobile__section_bottom__article_bottom">
                <aside class="container_dessinmobile__section_bottom__article_bottom__aside_left">
                    <router-link class="container_dessinmobile__section_bottom__article_bottom__aside_left__router-link"
                        to="/conception">
                        <button
                            class="container_dessinmobile__section_bottom__article_bottom__aside_left__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back">
                                <img src="@/assets/back.png" alt="back"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
                <!-- aside right -->
                <aside class="container_dessinmobile__section_bottom__article_bottom__aside_right">
                    <router-link
                        class="container_dessinmobile__section_bottom__article_bottom__aside_right__router-link"
                        to="/rendu-realiste">
                        <button
                            class="container_dessinmobile__section_bottom__article_bottom__aside_right__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next"  id="div_button">
                                <img src="@/assets/next.png" alt="next"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'DessinMobile',
}
</script>

<style  lang=scss>
router-link {
    display: block;
}

@import "@/style/components/Services/Mise-en-plan/DessinMobile.scss";

@media screen and(min-width: 926px) {
    #DessinMobile {
        display: none;
    }
}
</style>